var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 12",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.769 0c3.74 0 6.768 2.682 6.768 6s-3.028 6-6.768 6C3.029 12 0 9.31 0 6s3.028-6 6.769-6Zm10.81.355c1.865 0 3.383 2.525 3.383 5.645 0 3.12-1.518 5.645-3.384 5.645-1.865 0-3.384-2.525-3.384-5.645 0-3.12 1.518-5.645 3.384-5.645Zm5.23.586C23.466.94 24 3.202 24 6s-.534 5.06-1.19 5.06c-.657 0-1.191-2.27-1.191-5.06 0-2.79.534-5.06 1.19-5.06Z"
  })));
};

export default SvgMedium;